import React, { createContext, SetStateAction, useContext, useReducer, useState } from "react";
import { IDynamicParametersResponse } from "services/ParametersProviderApi";
import { isEqual } from 'lodash-es';

export enum EParametersActionType {
  SET_PARAMETERS = 'SET_PARAMETERS',
}

type TParametersAction = {
  type: EParametersActionType;
  value: IDynamicParametersResponse;
}

export const DynamicParametersContext = createContext<IDynamicParametersResponse>({});
export const DynamicParametersDispatchContext = createContext<React.Dispatch<React.SetStateAction<{}>> | null>(null);

const initialParameters = {};

export const useDynamicParameters = () => {
  const dynamicParameters = useContext(DynamicParametersContext);
  const dynamicParametersAreEmpty = Object.keys(dynamicParameters).length === 0;

  if (Object.keys(dynamicParameters).length > 0) {
    // set a dynamic parameter to test the hook
    // dynamicParameters.TEST_HOOK = 'TEST';
  }

  return { dynamicParameters, dynamicParametersAreEmpty };
}

export const useDynamicParametersDispatch = () => {
  return useContext(DynamicParametersDispatchContext);
}

export const dynamicParametersReducer: React.Reducer<IDynamicParametersResponse, TParametersAction> = (state: IDynamicParametersResponse, action: TParametersAction) => {
  switch (action.type) {
    case (EParametersActionType.SET_PARAMETERS): {
      return isEqual(state, action.value) ? state : { ...action.value };
    }
    default: {
      return state;
    }
  }
}

interface IDynamicParametersProviderProps {
  children: React.ReactNode;
}
export const DynamicParametersProvider: React.FC<IDynamicParametersProviderProps> = ({ children }) => {
  const [dynamicParameters, dispatch] = useReducer(dynamicParametersReducer, initialParameters);

  return (
    <DynamicParametersContext.Provider value={dynamicParameters}>
      <DynamicParametersDispatchContext.Provider value={dispatch}>
        {children}
      </DynamicParametersDispatchContext.Provider>
    </DynamicParametersContext.Provider>
  )
}
